import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '@spaced-out/ui-design-system/lib/components/Dialog';
import {
  BodyLarge,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';


type EditTaskConfirmationDialogProps = {
  isOpen: boolean;
  isUpdating?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const EditTaskConfirmationDialog = ({
  isOpen,
  isUpdating = false,
  onClose,
  onConfirm,
}: EditTaskConfirmationDialogProps) => {
  const {t} = useLabelTranslation();

  return (
    <Dialog isOpen={isOpen} iconName="list-check" onClose={onClose}>
      <DialogHeader>
        <SubTitleLarge>{t('Edit_Task', 'Edit Task')}</SubTitleLarge>
      </DialogHeader>
      <DialogBody>
        <BodyLarge color="secondary">
          {t(
            'Are_you_sure_you_want_to_update_this_task',
            'Are you sure you want to update this task?',
          )}
        </BodyLarge>
      </DialogBody>
      <DialogFooter>
        <Button
          isFluid
          type="tertiary"
          onClick={onClose}
          testId="task-edit-dialog-cancel"
        >
          {t('Cancel', 'Cancel')}
        </Button>
        <Button
          isFluid
          type="primary"
          onClick={onConfirm}
          isLoading={isUpdating}
          testId="task-edit-dialog-confirm"
        >
          {t('Update', 'Update')}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
